const HTTPS_URL_PATTERN = /^https:\/\/([a-z0-9-]+\.)*exodus\.io(:443)?([/?#]|$)/iu;
export function isExodusDomain(url) {
    try {
        if (typeof url !== 'string' || !HTTPS_URL_PATTERN.test(url)) {
            return false;
        }
        const { hostname, protocol, port } = new URL(url);
        if (protocol !== 'https:' || port !== '') {
            return false;
        }
        const normalizedHost = hostname.toLowerCase();
        return normalizedHost.endsWith('.exodus.io') || normalizedHost === 'exodus.io';
    }
    catch {
        return false;
    }
}
